import React, { useCallback, useEffect, useState } from 'react';
import { AiFillStar } from 'react-icons/ai';
import Card from 'src/components/card';
import DashboardLayout from 'src/containers/dashboard-layout';
import { RxCross2 } from 'react-icons/rx';
import { BsFillFileEarmarkPersonFill } from 'react-icons/bs';
import Table from 'src/components/table';
import { MdEdit } from 'react-icons/md';
import CrudIcon from 'src/components/crud-icon';
import Chart from 'src/components/chart';
import BarChart from '../back-office/__chart__data/barChart';
import Service from 'src/setup/network';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from 'src/redux/reducers';
import { fetchSetting } from 'src/redux/action/setting.action';
import { useDispatch } from 'react-redux';
import DateFormat from 'src/components/DateFormat';
import Loader from 'src/components/loader';

const FeedBack = () => {
  const [activeBar, setActiveBar] = useState<number>(0);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState('');
  const [feedbackData, setFeedBackData] = useState<any>([]);
  // const [since, setSince] = useState('');
  const [totalValue, setTotalValue] = useState<any>(0);
  const [dataValue, setDataValue] = useState<any>([]);

  const { settingData, loading } = useSelector(
    ({ settingData }: RootState) => settingData,
    shallowEqual
  );
  const fetchFeedbackData = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await Service.get(`feedbacks/info`);
      const data = await response?.data?.feedbackStat;
      // setSince(data?.since);
      setTotalValue(data?.count);
      const dataVal = data?.groupedFeedbacks.map((e: any) => e.count);
      setDataValue(dataVal?.reverse());
      setFeedBackData(data);
      setIsLoading(false);
    } catch (err: any) {
      setIsError(err);
      setIsLoading(false);
    }
  }, [settingData]);
  React.useEffect(() => {
    dispatch(fetchSetting() as any);
  }, [dispatch]);

  useEffect(() => {
    if (settingData?.businessInfo?.id) {
      fetchFeedbackData();
    } else {
      setIsLoading(true);
    }
  }, [settingData, fetchFeedbackData]);
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Card className="text-black flex pb-0 ">
            <div className="w-[243px] mr-[110px]">
              <div className="flex items-center space-x-2">
                <p className="text-[34px]">{feedbackData?.average}</p>
                <AiFillStar style={{ color: '#FEC02D' }} size={32} />
                <p className="text-base text-secondary-0">
                  based on {feedbackData?.count} ratings
                </p>
              </div>
              {/* <p className="text-base text-secondary-0">
                Ratings since{' '}
                <span>
                  {new Date(since)?.toLocaleString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                  })}
                </span>
              </p> */}
            </div>
            <div className="flex w-[400px] mt-[-30px]">
              <BarChart
                dataValues={dataValue}
                totalValue={totalValue}
                activeBar={activeBar}
                setActiveBar={setActiveBar}
              />
            </div>
          </Card>
          <div className="flex mt-6 justify-between space-x-6 pb-10">
            <Card className="flex-1 p-4">
              {feedbackData?.groupedFeedbacks?.map(
                (feedback: any, index: any) => {
                  return (
                    <>
                      {feedbackData?.groupedFeedbacks.length - 1 - index ==
                      activeBar ? (
                        <div>
                          <div className="flex justify-between">
                            <h1 className="font-bold text-base text-[black]">
                              {feedback?.stars} Stars Feedbacks
                            </h1>
                          </div>
                          <div className="text-[black] pb-3">
                            <div className="mt-2 flex flex-col">
                              {feedback?.feedbacks?.map((items: any) => {
                                // const factors = items?.factors.replace(
                                //   /_/g,
                                //   ' '
                                // );
                                return (
                                  <>
                                    <div className="text-[black] border-b border-border-color-dark pb-3 pt-3">
                                      <div className="text-[black] flex items-center space-x-2 mb-2">
                                        <p className="text-sm">
                                          {items?.rating}
                                        </p>
                                        <AiFillStar
                                          style={{ color: '#FEC02D' }}
                                          size={24}
                                        />
                                        <span className="text-secondary-0">
                                          {'  .'}
                                          {new Date(
                                            items?.createdAt
                                          ).toLocaleString('en-US', {
                                            year: 'numeric',
                                            month: 'short',
                                            day: 'numeric',
                                          })}
                                        </span>
                                      </div>
                                      <div className="flex gap-3">
                                        {items?.factors.map(
                                          (factor: string, index: number) => (
                                            <span className="w-fit capitalize bg-[#F1F0F6] px-2 py-1">
                                              {factor.replace(/_/g, ' ')}
                                            </span>
                                          )
                                        )}
                                      </div>
                                      <div>
                                        <p className="text-sm mt-2">
                                          {items?.comment}
                                        </p>
                                        <p className="text-sm text-secondary-0 mt-1">
                                          <span>{items?.userInfo?.name}</span> -{' '}
                                          <span className="capitalize">
                                            {items?.origin}
                                          </span>
                                        </p>
                                      </div>
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      ) : (
                        ''
                      )}
                    </>
                  );
                }
              )}
            </Card>
          </div>
        </>
      )}
    </>
  );
};

export default FeedBack;
